module.exports = __webpack_public_path__ + "static/media/network-wired-solid.03fa3ec5.svg";